const Company = () => {
  return (
    <div className="text-center mb-1 mt-1">
      <p className="text-center text-sm text-gray-600 whitespace-nowrap">
        © 2025 Kȧlpȧnecha Karkhana Private Limited
      </p>
    </div>
  );
};

export default Company;
